import { render } from "./GuestFooter.vue?vue&type=template&id=40c9c4fa&scoped=true"
import script from "./GuestFooter.vue?vue&type=script&lang=js"
export * from "./GuestFooter.vue?vue&type=script&lang=js"

import "./GuestFooter.vue?vue&type=style&index=0&id=40c9c4fa&scoped=true&lang=css"

import exportComponent from "D:\\SMS-Syariah\\server\\app\\sms pay corporate\\sms-pay-corporate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c9c4fa"]])

export default __exports__